import React from "react";
import css from "./WithCordovaIntro.module.css";
import {BlogView} from "Components";


export default function WithCordovaIntro(props){
    const {}=props;
    return (
        <BlogView className={css.withcordovaintro}
            sections={[
                {
                    title:"with Cordova",
                    text:`
                        Every code snippet and example provided in this section will presume 
                        that we are working within an app that was generated using the <span>create-vritra-app</span> npx command
                    `,
                    notice:`
                    Ultimately, all Vritra-plugins are essentially Cordova plugins, which means they can be employed and added 
                    to any Cordova project. If you wish to utilize these plugins separately, you can refer 
                    to the <a href="#cordovaplugins">Cordova plugins</a> section for guidance and documentation
                    `,
                }
            ]}
        />
    )
}
